import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { UpdatePopupProps, CloseActivePopup } from '../../../../actions/popupActions';
import LevelSettingsModeEnum from './enums';
import { PopupTypes } from '../../Enums';
import Header from './header';
// Level settings imports
import { setAllLevelSettings } from '../../../../actions/levelSettingsActions';
// Game(Kit) imports
import gameKit from '../../../../../GameKit';
import { GameGoalFlag } from '../../../../../Game/Enums';
import settings from '../../../../../settings';

class LevelSettingsMain extends React.Component {
    constructor(props) {
        super(props);

        this.buttonClass = 'level-settings-main-button';
    }

    uploadLevelSettingsToStore = () => {
        const { dispatch, levelUuid } = this.props;

        const currentLevel = gameKit.game.levels.findByUUID(levelUuid);

        dispatch(setAllLevelSettings({
            title: currentLevel.title,
            description: currentLevel.description,
            backgroundColorA: currentLevel.backgroundColorA,
            backgroundColorB: currentLevel.backgroundColorB,
            view: currentLevel.viewDirection,
            timeLimit: currentLevel.timeLimit,
            pointsGoal: currentLevel.pointsGoal
        }));
    }

    handleChangeLevelGoal = () => {
        const { dispatch, fromLevelGrid, levelUuid } = this.props;
        dispatch(
            UpdatePopupProps(PopupTypes.LEVEL_SETTINGS, {
                mode: LevelSettingsModeEnum.LEVEL_GOAL,
                fromLevelGrid,
                levelUuid
            })
        );
    };

    handleChangeLevelView = () => {
        const { dispatch, fromLevelGrid, levelUuid } = this.props;
        dispatch(
            UpdatePopupProps(PopupTypes.LEVEL_SETTINGS, {
                mode: LevelSettingsModeEnum.LEVEL_VIEW,
                fromLevelGrid,
                levelUuid
            })
        );
    };

    handleClose = () => {
        const { dispatch } = this.props;
        dispatch(CloseActivePopup());
    };

    GoalImage = () => {
        const { game } = this.props;
        let img = 'levelsettings_monstertje.png';
        if (game.goal & GameGoalFlag.TIME_LIMIT && game.goal & GameGoalFlag.POINT_LIMIT) {
            img = 'levelsettings_monstertje_alle.png';
        } else if (game.goal & GameGoalFlag.POINT_LIMIT) {
            img = 'levelsettings_monstertje_punten.png';
        } else if (game.goal & GameGoalFlag.TIME_LIMIT) {
            img = 'levelsettings_monstertje_tijd.png';
        }

        return <img src={`${settings.assetsPath}img/${img}`} alt="Hulp monstertje" className="img-monster" />;
    };

    render = () => {
        return (
            <div id="level-settings-main">
                <Header />
                <this.GoalImage />
                <button className={`${this.buttonClass}`} type="button" onClick={this.handleChangeLevelGoal}>
                    Levelopdracht toevoegen
                </button>
                <button className={`${this.buttonClass}`} type="button" onClick={this.handleChangeLevelView}>
                    Level-aanzicht veranderen
                </button>
                <button className={`${this.buttonClass}-close`} type="button" onClick={this.handleClose}>
                    sluit
                </button>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelSettingsMain);
